import React from 'react'
import { ButtonContainer } from './styles'
import { IconComponent } from '~/assets/icons/component'

export interface ExpandAndCollapseButtonProps {
  isCollapsed: boolean
  onClick: (newState: boolean) => void
  collapsedDirection?: 'left' | 'right'
}

/**
 * This component will render a open/close button with a arrow icon (chevrons) and a callback function
 * @param {boolean} isCollapsed - boolean to indicate if the button is collapsed or not
 * @param {ExpandAndCollapseButtonProps['onClick']=} onClick - callback function to be called when the button is clicked (it will receive the new state)
 * @param {ExpandAndCollapseButtonProps['collapsedDirection']=} collapsedDirection - direction of the arrow (starts with left or right)
 * @returns {JSX.Element} return the rendered button
 * @example
 * const [isCollapsed, setIsCollapsed] = useState<boolean>(false)
 * <ExpandAndCollapseButton onClick={setIsCollapsed} isCollapsed={isCollapsed} collapsedDirection="left" />
 */

export const ExpandAndCollapseButton = ({
  onClick,
  isCollapsed,
  collapsedDirection = 'right'
}: ExpandAndCollapseButtonProps): JSX.Element => {
  const collapsedIsOnRight = isCollapsed ? 'chevronsRight' : 'chevronsLeft'
  const collapsedIsOnLeft = isCollapsed ? 'chevronsLeft' : 'chevronsRight'

  const handleToggle = (event: React.MouseEvent): void => {
    event.stopPropagation()
    onClick(!isCollapsed)
  }

  return (
    <ButtonContainer onClick={handleToggle}>
      <IconComponent name={collapsedDirection === 'left' ? collapsedIsOnLeft : collapsedIsOnRight} />
    </ButtonContainer>
  )
}
